import Configurations from '../../common/utils/configurations';
import { useState } from 'react';

export default function useConfirmAccountPatient() {
    const [noNeedEmail, setNoNeedEmail] = useState(false);

    const executeValidation = async (identifier) => {
        if (!identifier) return false;

        try {
            const attemptToValidate = await fetch(`${Configurations.API_SERVER}/auth/validate-email?id=${identifier}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            return attemptToValidate && attemptToValidate.status < 400;
        } catch (e) {}
    };
    const sendNewEmail = async (email) => {
        if (!email) return false;

        try {
            const attemptToSend = await fetch(
                `${Configurations.API_SERVER}/auth/send-new-validation-email?email=${email}`,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (attemptToSend && attemptToSend.status === 401) {
                setNoNeedEmail(true);
                return true;
            }

            return attemptToSend && attemptToSend.status < 400;
        } catch (e) {
            return false;
        }
    };

    return { executeValidation, sendNewEmail, noNeedEmail, setNoNeedEmail };
}
